import Labyrinthen from './Labyrinthen';

export default Labyrinthen;